/**
 * 禁止H5 弹窗下边的页面滚动
 * 明确声明为不是被动的
 * 缺陷：会导致页面滚动到顶部
 */
export function stopScroll() {
  const sTop = document.documentElement.scrollTop || document.body.scrollTop
  document.body.className = document.body.className + ' c-global-parent-overflow'
  document.body.style.top = -sTop + 'px'
  document.body.dataset.top = sTop
}
export function openScroll() {
  removeClass(document.body, 'c-global-parent-overflow')
  const top = document.body.dataset.top
  document.documentElement.scrollTop = top
  const sTop = document.documentElement.scrollTop || document.body.scrollTop
  !sTop && (document.body.scrollTop = top)
  document.removeEventListener('touchmove', bodyScroll, {
    capture: false,
    passive: false,
    once: false,
  })
}

function bodyScroll(e) {
  e.preventDefault()
}
function removeClass(el, name) {
  if (!el) return
  const className = el.className
  if (className) {
    const reg = new RegExp(name, 'g')
    el.className = className.replace(reg, '')
  }
}
